import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { FiEye, FiEyeOff } from "react-icons/fi";

export default function AddCustomerModal({ show, onHide, onReopen }) {
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [showPass, setShowPass] = useState(false);

  const close = () => {
    onHide();
    onReopen && onReopen();
  };

  // IMAGE UPLOAD
  const handleImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  return (
    <Modal
      show={show}
      onHide={close}
      backdrop={false}
      centered
      size="lg"
      className="custom-modal"
    >
      {/* HEADER */}
      <Modal.Header closeButton>
        <Modal.Title>Add New Customer</Modal.Title>
      </Modal.Header>

      {/* BODY */}
      <Modal.Body>
        {/* UPLOAD */}
        <div className="upload-box mb-4">
          <div className="upload-circle">
            {preview && <img src={preview} alt="preview" />}
          </div>

          <div>
            <p className="fw-medium mb-1">Upload Profile Image</p>
            <small className="text-muted">Image should be below 4 mb</small>

            <div className="mt-2 d-flex gap-2">
              <label className="btn btn-orange btn-sm mb-0">
                Upload
                <input type="file" hidden onChange={handleImage} />
              </label>
              <Button
                variant="light"
                size="sm"
                onClick={() => setPreview(null)}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>

        {/* FORM */}
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>First Name *</Form.Label>
              <Form.Control />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Last Name *</Form.Label>
              <Form.Control />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>User Name *</Form.Label>
              <Form.Control />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Email *</Form.Label>
              <Form.Control type="email" />
            </Form.Group>
          </Col>

          {/* PASSWORD */}
          <Col md={6}>
            <Form.Group className="mb-3 position-relative">
              <Form.Label>Password *</Form.Label>
              <Form.Control type={showPass ? "text" : "password"} />
              <span className="eye-icon" onClick={() => setShowPass(!showPass)}>
                {showPass ? <FiEyeOff /> : <FiEye />}
              </span>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3 position-relative">
              <Form.Label>Confirm Password *</Form.Label>
              <Form.Control type="password" />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Phone Number *</Form.Label>
              <Form.Control />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Company *</Form.Label>
              <Form.Control />
            </Form.Group>
          </Col>

          <Col md={12}>
            <Form.Group>
              <Form.Label>Address *</Form.Label>
              <Form.Control as="textarea" rows={2} />
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>

      {/* FOOTER */}
      <Modal.Footer>
        <Button variant="light" onClick={onHide}>
          Cancel
        </Button>
        <Button className="btn-orange">Save</Button>
      </Modal.Footer>

      {/* INTERNAL CSS */}
      <style>
        {`
        .custom-modal .modal-content {
          border-radius: 10px;
          padding: 10px;
        }

        .upload-box {
          display: flex;
          gap: 15px;
          background: #f9fafb;
          padding: 15px;
          border-radius: 8px;
          align-items: center;
        }

        .upload-circle {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          border: 1px dashed #d1d5db;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }

        .upload-circle img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .btn-orange {
          background: #ff6a00;
          border: none;
          color: #fff;
        }

        .btn-orange:hover {
          background: #e85d00;
        }

        .form-control {
          border-radius: 6px;
          font-size: 14px;
        }

        /* ORANGE FOCUS */
        .form-control:focus {
          border-color: #ff6a00;
          box-shadow: 0 0 0 0.2rem rgba(255,106,0,0.2);
        }

        /* PASSWORD ICON */
        .eye-icon {
          position: absolute;
          right: 10px;
          top: 38px;
          cursor: pointer;
          color: #777;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .upload-box {
            flex-direction: column;
            align-items: flex-start;
          }

          .eye-icon {
            top: 35px;
          }
        }
        `}
      </style>
    </Modal>
  );
}
